module.exports = __webpack_public_path__ + "img/question-bg-mobile.77e1bc87.png";